

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import report from '@/components/data/report.vue';
import { searchByName } from '@/api/common';
import moment from 'moment';
import { USDIRColumns } from '@/utils/report';
import { getCommonList } from '@/api/common';

const url = '/dataService/reportForm/irUsd/queryList';

const downloadUrl = '/dataService/reportForm/irUsd/download';

@Component({
  components: { report }
})
class USDIRREPORT extends Vue {
  sectorList: any[] = [];
  NickNameList: any[] = [];
  projectName: string = '';
  sector: string = 'all sectors';
  dlId: string = '';
  url: string = url;
  endDate: string = '';
  downloadUrl: string = downloadUrl;
  fileName: string = '';
  USDIRColumns: any[] = USDIRColumns;
  industry: string = '';

  get requestData() {
    const { dlId, projectName, endDate } = this;
    if (this.sector === 'all sectors') {
      this.industry = '';
    } else {
      this.industry = this.sector;
    }
    return {
      sector: this.industry,
      dlId,
      projectName,
      endDate
    };
  }

  mounted() {
    let date = moment(new Date()).format('YYYYMMDD');
    this.fileName = `美元IR数据报表_${date}`;
    this.getSector();
    this.getSelects();
  }

  async getSector() {
    try {
      let res = await getCommonList();
      if (res.code === 200) {
        this.sectorList = res.data.industry || [];
        this.sectorList.unshift({ id: '', enName: 'all sectors' });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getSelects() {
    try {
      let res = await searchByName();
      if (res.code === 200) {
        this.NickNameList = res.data.list;
        this.NickNameList.unshift({ id: '', nickname: '全部项目负责人' });
      }
    } catch (err) {
      console.log(err);
    }
  }

  handleSearch(val) {
    this.projectName = val;
  }

  onChange(date, dateString) {
    this.endDate = date ? moment(date).format('YYYYMMDD') : '';
  }

  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
export default USDIRREPORT;
